import React, { useMemo } from 'react';
import { LayoutProps } from 'src/types/LayoutProps';
import { AlertDialogComponent } from '../common/AlertDialogComponent';
import Loader from '../common/Loader';
import { SnackbarComponent } from '../common/SnackbarComponent';
import { StyledComponent } from '../common/Styled';
import Navbar from '../header/Navbar';
import { useTab } from '../hooks/useTab';
import Main from './Main';

const RootStyle = StyledComponent('div')({
  display: 'flex',
  minHeight: '100%',
  overflow: 'hidden'
});

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const { tabVal, tabsData } = useTab();
  const isStudyLogTab: any = useMemo(() => {
    const find: any = tabsData.find((ele: any) => Number(ele.index) === Number(tabVal));
    return find;
  }, [tabVal, tabsData]);
  return (
    <RootStyle>
      <Navbar />
      <Main>{children}</Main>
      <SnackbarComponent />
      {isStudyLogTab?.key !== 'studyLogs' ? <Loader /> : null}
      <AlertDialogComponent />
    </RootStyle>
  );
};

export default Layout;
